import { DefaultAdminHandler } from '../../../details/services/default-admin-handler';
import { Injectable } from '@angular/core';
import { FormDefinition } from '@feature/_app_modules/dynamic-forms/dynamic-form';
import { addColumnFieldsToAdminForm, WidgetAdminHandler } from '@feature/widget-admin';
import { WidgetColumnsHttpService } from '@feature/widget-columns/services/widget-columns-http.service';
import { WidgetConfiguration } from '@feature/widget-configs';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WidgetDefaultColumnHandlerService implements WidgetAdminHandler {

  private formDefinition : Observable<FormDefinition>;

  constructor(
    private readonly widgetColumnsHttp: WidgetColumnsHttpService,
    private readonly defaultAdminHandler: DefaultAdminHandler
  ) { }

  initialise(): boolean | Observable<boolean> {
    return true;
  }
  getAdminForm(selectedConfig: WidgetConfiguration): FormDefinition | Observable<FormDefinition> {
    const getAllColumns = this.widgetColumnsHttp.getAllColumns(selectedConfig.id);

    const result = getAllColumns.pipe(map(columns => {
      let formDefinition = this.defaultAdminHandler.getAdminForm(selectedConfig);

      formDefinition = addColumnFieldsToAdminForm(selectedConfig, columns, formDefinition);

      return formDefinition; 
    }));
    
    return result;
  }
  createCopyFromAdminForm(selectedConfig: WidgetConfiguration, adminFormValue: any): Observable<boolean> {
    return this.defaultAdminHandler.createCopyFromAdminForm(selectedConfig, adminFormValue);
  }
  saveConfigFromAdminForm(selectedConfig: WidgetConfiguration, adminFormValue: any): Observable<boolean> {
    return this.defaultAdminHandler.saveConfigFromAdminForm(selectedConfig, adminFormValue);
  }
  deleteConfigFromAdminForm(selectedConfig: WidgetConfiguration, adminFormValue: any): Observable<boolean> {
    return this.defaultAdminHandler.deleteConfigFromAdminForm(selectedConfig, adminFormValue);
  }
}
